"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeWithExecutionTimeMeasurement = executeWithExecutionTimeMeasurement;
async function executeWithExecutionTimeMeasurement(fn, onElapsedTime) {
    const start = Date.now();
    return fn().finally(() => {
        const end = Date.now();
        const elapsedTime = end - start;
        onElapsedTime(elapsedTime);
    });
}
//# sourceMappingURL=executeWithExecutionTimeMeasurement.js.map